import PropertyWithoutSliderContainer from "../../../components/property/listing/PropertyWithoutSlider";

const PropertyWithoutSlider = () => {
  return <PropertyWithoutSliderContainer />;
};

export default PropertyWithoutSlider;
